export const version = "bignumber/5.2.0";
